#import "../../../graphql/fragments/inbox-channel-event-fragment.graphql"

query GetScheduledMessages($channelId: ID!, $threadId: ID) {
    scheduledMessages(channelId: $channelId, threadId: $threadId) {
        edges {
            node {
                ...InboxChannelEventFragment
            }
        }
    }
}
